var React = require('react');

function Truck1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M67.9177 321H146V0H84.0886C76.2342 43.2026 42.0443 63.178 0 64.5716V117.53H67.9177V321Z","fill":"white"}));
}

Truck1.defaultProps = {"width":"146","height":"321","viewBox":"0 0 146 321","fill":"none"};

module.exports = Truck1;

Truck1.default = Truck1;
